import { IJob as IJobModel } from '~/models';
import { IJob, IJobApi } from '../types/jobsTypes';

function toJob(jobApi: IJobApi): IJob {
  return {
    id: jobApi.id,
    rate: jobApi.rate,
    status: jobApi.status,
    multipleCounters: jobApi.multipleCounters,
    jobDatetime: jobApi.job_datetime,
    professionName: jobApi.professionName,
    profession: jobApi.profession,
    localEndTime: jobApi.local_end_time,
    localStartTime: jobApi.local_start_time,
    total: jobApi.total,
    jobApi: jobApi as unknown as IJobModel,
  };
}

export const jobsAdapter = {
  toJob,
};
